import { User } from "./userTypes";

export interface Product {
  documentId: string;
  createdTime: number;
  isDeleted: boolean;
  productCategory: string;
  productCategoryName: string;
  productCategorySlug: string;
  productCondition: string;
  productDescriprion: string;
  productImage: string;
  productImageOne: string;
  productImageThree: string;
  productImageTwo: string;
  productName: string;
  productOwner: string;
  productPrice: string;
  price: number;
  productQuantity: number;
  productSubCategory: any;
  productSubCategoryName: string;
  productSubCategorySlug: string;
  productUrl: string;
  productUsaShipping: string;
  views: number;
  score: number;
  cartQuantity?: number; // Quantity in cart
}

export interface ProductPageData {
  products: Product[];
  moreProducts: Product[];
  similarProducts: Product[];
  sellerInfo: User;
}

export interface SellerPageData {
  products: Product[];
  totalRecords: number;
  sellerInfo: User;
}

export interface ProductState {
  productsData: {
    products: Product[];
    totalRecords: number;
    moreProducts: Product[];
    similarProducts: Product[];
    sellerInfo: User;
  };
  loading: boolean;
  error: string | null;
}

export const FREE_SHIPPING_PRICE = "$0.00";
